import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <h3>ULTRAZE <span className="highlight">FA</span></h3>
          <p>Une histoire vraie • Racontée avec le cœur</p>
        </div>
        <div className="footer-info">
          <p>© 2026 BLF - Tous droits réservés</p>
          <p>Histoire racontée par BLF</p>
        </div>
      </div>

      <div className="footer-disclaimer">
        <p className="disclaimer-text">
          ℹ️ Ce site ne porte atteinte à personne, ne contient aucun hack. Le nom de domaine appartient légitimement à BLF.
        </p>
      </div>
    </footer>
  );
};

export default Footer;